/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWatchlistCommand } from '../../models/create-watchlist-command';
import { WatchlistModelResult } from '../../models/watchlist-model-result';

export interface ApiWatchlistCreatePost$Json$Xml$Params {
      body?: CreateWatchlistCommand
}

export function apiWatchlistCreatePost$Json$Xml(http: HttpClient, rootUrl: string, params?: ApiWatchlistCreatePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistCreatePost$Json$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelResult>;
    })
  );
}

apiWatchlistCreatePost$Json$Xml.PATH = '/api/watchlist/create';
